import Submenu from "./index";
import { SubContent } from "../Layout";
import useFormatDate from "../../hooks/utils/useFormat";
import MenuItem from "../MenuItem";
import { NavLink } from "react-router-dom";

export default function TraineeSubMenu(props) {
  const { trainee } = props;
  const { formatPhone } = useFormatDate();

  return (
    <>
      {!!trainee && (
        <>
          <SubContent className="mb-3">
            <h2 className="mini-title mb-1">{trainee?.name}</h2>
            <p className="m-0 small-label">
              <NavLink to={`/groups/${trainee?.commercial_id}/registrationdata`} target="_blank">
                <b>{trainee?.commercial_label}</b>
              </NavLink>
            </p>
            <p className="m-0 small-label">
              {formatPhone(trainee?.cell)}
              {!!trainee?.phone && <span className="ml-2">{formatPhone(trainee?.phone)}</span>}
            </p>
            <p className="m-0 small-label">{trainee.email}</p>
          </SubContent>
          <SubContent className="p-0">
            <MenuItem href={`/trainees/edit/${trainee?.id}`}>Dados do Formando</MenuItem>
            <MenuItem href={`/trainees/financial/${trainee?.id}`}>Financeiro Contratado</MenuItem>
            <MenuItem href={`/trainees/charges/${trainee?.id}`}>Cobranças Extras</MenuItem>
            <MenuItem href={`/trainees/products/${trainee?.id}`}>Produtos Adquiridos</MenuItem>
            <MenuItem href={`/trainees/attendance/${trainee?.id}`}>Atendimentos</MenuItem>
          </SubContent>
        </>
      )}
    </>
  );
}
